import { IHeader } from './model';

export const TIMEOUT = 10000;

export const MINIMAL_TIMEOUT_BETWEEN_REQUESTS = 1000;

export const EXPONENTIAL_GROWTH_FACTOR = 2;

export const NUMBER_OF_RETRIES = 2;
export const GRAPHQL_HEADER: IHeader[] = [{ 'X-Request-Type': 'GraphQl' }];

export enum ERetryWorthErrors {
  TIMEOUT_ERROR = 408,
  TOO_MANY_REQUESTS_ERROR = 429,
  NO_RESPONSE_ERROR = 444,
  REQUEST_CLOSED_ERROR = 499,
  SERVICE_UNAVAILABLE_ERROR = 503,
  GATEWAY_TIMEOUT_ERROR = 504,
  NETWORK_READ_TIMEOUT_ERROR = 598,
  NETWORK_CONNECT_TIMEOUT_ERROR = 599,
}

export enum EExcludeFromLogsErrors {
  CANCELED = 0,
  BAD_REQUEST = 400,
  TIMEOUT_ERROR = 408,
  TOO_MANY_REQUESTS_ERROR = 429,
  REQUEST_CLOSED_ERROR = 499,
  NETWORK_READ_TIMEOUT_ERROR = 598,
  NETWORK_CONNECT_TIMEOUT_ERROR = 599,
}

export const ERROR_CODES: { errorCode: string; error: ERetryWorthErrors }[] = [
  { errorCode: 'ECONNABORTED', error: ERetryWorthErrors.TIMEOUT_ERROR },
];

export const UNRECOGNIZED_ERROR = 0;
